import MainSection from 'components/desktop/detail/main-section';
import SimilarCardList from 'components/desktop/detail/similar-card-list';
import SimilarDepositCardList from 'components/desktop/detail/similar-deposit-card-list';
import Footer from 'components/desktop/shared/footer';
import Header2 from 'components/desktop/shared/header2';
import {
  GET_REAL_ESTATE_DETAILS,
  GetRealEstateDetailsData,
  GetRealEstateDetailsVariables,
  RealEstate,
} from 'graphql/main/queries';
import { useFlexQuery } from 'hooks';
import { DetailPageContext } from 'pages/[ket-qua-tim-kiem]/[chi-tiet-tin-rao]';
import { Context, Fragment, createContext, useContext } from 'react';
import SimilarLeadCardList from './similar-lead-card-list';

export const DetailPageClientContext: Context<Props> = createContext({});

interface Props {
  pageData?: {
    realEstate?: RealEstate;
  };
}

const Detail = () => {
  const { realEstate } = useContext(DetailPageContext).pageData ?? {};
  const { id } = realEstate ?? {};
  const { data: getRealEstateDetailsData } = useFlexQuery<
    GetRealEstateDetailsData,
    GetRealEstateDetailsVariables
  >('main', GET_REAL_ESTATE_DETAILS, {
    variables: {
      id,
    },
  });
  const { getRealEstateDetails: realEstateClient } = getRealEstateDetailsData ?? {};

  return (
    <Fragment>
      <Header2 />
      <DetailPageClientContext.Provider
        value={{
          pageData: {
            realEstate: realEstateClient,
          },
        }}
      >
        <main className='flex min-h-[1000px] min-w-[1052px] flex-col'>
          <div className='my-[28px] flex flex-col space-y-[28px]'>
            <MainSection />
            {/* <Advertisment /> */}
            <SimilarLeadCardList />
            <SimilarDepositCardList />
            <SimilarCardList />
          </div>
        </main>
      </DetailPageClientContext.Provider>
      <Footer />
    </Fragment>
  );
};

export default Detail;
